import React, { FC } from 'react';
import styled from 'styled-components';

import { mediaQuery } from 'src/themes/breakpoints';
import Heading, { HeadingVariant } from 'src/components/Heading';
import { colors } from 'src/themes/colors';
import Service from './Service';

const Wrapper = styled.div`
  background-color: ${colors.blue};
  padding: 30px 0 50px;
  width: 100%;

  ${mediaQuery('md')} {
    padding: 100px 0 140px;
  } ;
`;

const Content = styled.div`
  display: grid;
  grid-gap: 40px;
  grid-template-columns: 1fr;
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 20px;

  ${mediaQuery('md')} {
    grid-template-columns: repeat(3, 1fr);
  } ;
`;

const Title = styled(Heading)`
  color: ${colors.grey100};
  margin-bottom: 30px;
  text-align: center;

  ${mediaQuery('md')} {
    margin-bottom: 60px;
  } ;
`;

interface ServicesProps {
  title: string;
  services: any;
}

const Services: FC<ServicesProps> = ({ title, services }) => (
  <Wrapper>
    <Title variant={HeadingVariant.BRAVO}>{title}</Title>
    <Content>
      {services &&
        services.map((service, idx) => (
          <Service
            key={idx}
            icon={service.icon.publicURL}
            title={service.title}
            text={service.text}
          />
        ))}
    </Content>
  </Wrapper>
);

export default Services;
